import PropTypes from "prop-types";
import { StyledTable } from "../../cuentas/components/cuentasComponents";
import {
  columns,
  customStyles,
  opcionesdepagina,
} from "../../cuentas/components/tableOptions";

function GenericStyledTable({ column, dataset }) {
  return (
    <StyledTable
      responsive
      columns={columns(column)}
      data={dataset}
      customStyles={customStyles}
      pagination
      paginationRowsPerPageOptions={[10, 25, 50, 100,500,800,1000]}
      paginationComponentOptions={opcionesdepagina}
      fixedHeader
      fixedHeaderScrollHeight="600px"
      highlightOnHover
      noDataComponent={<div>No hay informacion disponible para mostrar</div>}
    />
  );
}

GenericStyledTable.propTypes = {
  column: PropTypes.string,
  dataset: PropTypes.array,
};

export default GenericStyledTable;
